import { render, staticRenderFns } from "./software.vue?vue&type=template&id=0e7bfd45&scoped=true&"
import script from "./software.vue?vue&type=script&lang=js&"
export * from "./software.vue?vue&type=script&lang=js&"
import style0 from "./software.vue?vue&type=style&index=0&id=0e7bfd45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7bfd45",
  null
  
)

export default component.exports